import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExitIcon } from "@vfit/ui/icons";
import { Background, Container, ModalContent, Padder } from "./modal.style";
var Modal = function(props) {
    var children = props.children, show = props.show, onCloseModal = props.onCloseModal, isDetailsModal = props.isDetailsModal, withBorderRadius = props.withBorderRadius, height = props.height, tabletMode = props.tabletMode, customId = props.customId, isDisabledClose = props.isDisabledClose;
    if (!show) {
        return null;
    }
    var onClickHandler = function() {
        onCloseModal === null || onCloseModal === void 0 ? void 0 : onCloseModal();
    };
    return /*#__PURE__*/ _jsx(Background, {
        children: /*#__PURE__*/ _jsxs(Container, {
            id: customId,
            isDetailsModal: isDetailsModal,
            withBorderRadius: withBorderRadius || false,
            tabletMode: tabletMode,
            maxHeight: height,
            children: [
                !isDisabledClose && /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("span", {
                        role: "button",
                        tabIndex: 0,
                        className: "closing-icon",
                        onClick: onClickHandler,
                        onKeyDown: onClickHandler,
                        children: /*#__PURE__*/ _jsx(ExitIcon, {})
                    })
                }),
                /*#__PURE__*/ _jsx(ModalContent, {
                    className: "modalContent",
                    height: height,
                    children: /*#__PURE__*/ _jsx(Padder, {
                        children: children
                    })
                })
            ]
        })
    });
};
export default Modal;
